import { useCallback } from "react";
import { useHistory, useParams } from "react-router-dom";

const usePagination = () => {
  const history = useHistory();
  const { page = 1 } = useParams();

  const onPageClick = useCallback(
    (nextPage: number) => {
      const { pathname } = history.location;

      const matched = /(.+)\/\d+$/g.exec(pathname);
      const rootPath = matched ? matched[1] : pathname;

      history.push(`${rootPath}/${nextPage}`);
    },
    [history]
  );

  return [page, onPageClick];
};

export default usePagination;
